/* Iberic Deco - bloque de confianza en ficha de producto.
   Solo afirmaciones verificadas contra las politicas de la tienda. */
(function () {
  'use strict';

  if (window.__ibericTrust) return;
  window.__ibericTrust = true;

  var ITEMS = [
    'Envío gratis en pedidos desde 100 €',
    '15 días para devolver, uno más que el mínimo legal',
    'Garantía legal de 3 años'
  ];

  var CHECK =
    '<' + 'svg class="iberic-trust__check" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M2.5 8.5L6 12L13.5 4" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init() {
    if (!/\/products\//.test(window.location.pathname)) return;

    var btn = document.querySelector('.add-to-cart-button');
    if (!btn) return;

    /* Colgar del contenedor del boton, no del boton mismo */
    var anchor = btn.closest('add-to-cart-component') || btn.parentElement;
    if (!anchor || !anchor.parentElement) return;
    if (anchor.parentElement.querySelector('.iberic-trust')) return;

    var box = document.createElement('div');
    box.className = 'iberic-trust';

    var html = '';
    for (var i = 0; i < ITEMS.length; i += 1) {
      html +=
        '<div class="iberic-trust__item">' + CHECK +
        '<span>' + ITEMS[i] + '</span></div>';
    }
    html +=
      '<div class="iberic-trust__pay">' +
      '<b>Pago seguro</b><span>Tarjeta, Apple Pay, Google Pay y Shop Pay</span>' +
      '</div>';

    box.innerHTML = html;
    anchor.parentElement.insertBefore(box, anchor.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
